module.exports = "/img/iqos_logo.svg?7d56966432ba5ef715a6648321fefeab";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/iqos/iqos_logo.svg
// module id = w1ag
// module chunks = 44